export default "__VITE_ASSET__D6W9FP3x__"